module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (!locals.complete) { 
    ; __append(" <p> Please fill out at least \"to address\", \"from address\", \"parcel\", and \"shipment options\" before proceeding to choose a label. </p> ")
    ;  } else if (locals.rates && locals.rates.length > 0) { 
    ; __append(" <div class=\"form-inline\"> <div class=\"form-group\"> <label class=\"mr-sm-2 h6\">Show rates for:</label> <select id=\"carrier-list\" class=\"form-control form-control-lg\"> ")
    ;  _.each(locals.availableCarriers, function(carrier) {
    ; __append(" <option ")
    ;  if (carrier === locals.currentCarrier) { 
    ; __append(" selected=\"selected\" ")
    ;  } 
    ; __append("> ")
    ; __append(escapeFn( carrier ))
    ; __append(" </option> ")
    ;  }) 
    ; __append(" </select> </div> </div> <hr> <div class=\"list-group\"> ")
    ;  _.each(locals.rates, function(rate) { 
    ; __append(" ")
    ;  var itemClass = ''; 
    ; __append(" ")
    ;  if (locals.buying && rate.id == locals.buying) { 
    ; __append(" ")
    ;  itemClass = 'active'; 
    ; __append(" ")
    ;  } else if (locals.buying) { 
    ; __append(" ")
    ;  itemClass = 'disabled'; 
    ; __append(" ")
    ;  } 
    ; __append(" <a class=\"buy-label list-group-item list-group-item-action ")
    ; __append(escapeFn( itemClass ))
    ; __append(" \" href=\"#\" data-rate=\"")
    ; __append(escapeFn( rate.id ))
    ; __append("\"> <div> <h5 class=\"my-0\"> ")
    ; __append(escapeFn( rate.carrier ))
    ; __append("  ")
    ; __append(escapeFn( rate.service ))
    ; __append(" - ")
    ; __append(escapeFn( rate.display_rate ))
    ; __append(" </h5> ")
    ;  if (rate.delivery_date) { 
    ; __append(" <small>Delivery ")
    ; __append(escapeFn( rate.delivery_date ))
    ; __append("</small> ")
    ;  } 
    ; __append(" </div> </a> ")
    ;  }) 
    ; __append(" </div> ")
    ;  } else { 
    ; __append(" <h3>Loading...</h3> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/create/modal/choose_label_template.ejs
// module id = 1826
// module chunks = 1